import { render, staticRenderFns } from "./satker_bidang.vue?vue&type=template&id=7900d2d8&"
import script from "./satker_bidang.vue?vue&type=script&lang=js&"
export * from "./satker_bidang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports